// extracted by mini-css-extract-plugin
export default {"root":"ItemDateRange_root__l3kWJ","rootIcon":"ItemDateRange_rootIcon__bnCZF"};